import { EditOutlinedIcon, IconButton } from '@shared/components';

import { useManuallyEditQSetModal } from '../../providers';

interface EditQSetButtonProps {
  examEventId: string;
}

export default function EditQSetButton(props: Readonly<EditQSetButtonProps>) {
  const { examEventId } = props;

  const { setAction } = useManuallyEditQSetModal();

  const handleClick = () => {
    setAction({ type: 'manually-edit-qset', examEventId });
  };

  return (
    <IconButton onClick={handleClick} aria-label='Edit QSet'>
      <EditOutlinedIcon />
    </IconButton>
  );
}
